export enum cookies {
  VIEW_TYPE = 'ddSearchViewPreferenceV2',
  TDP_MODAL_SEEN = 'ddSearchTdpAgriModalSeen',
}
